module.exports = __webpack_public_path__ + "static/media/bo3.696f9a61.jpg";